import { Slot } from "@radix-ui/react-slot";
import clsx from "clsx";
import { HTMLAttributes, forwardRef } from "react";
import classes from "./text.module.css";

export type TextProps = HTMLAttributes<HTMLElement> & {
  asChild?: boolean;
  maxLines?: number;
};

export const Text = forwardRef<HTMLElement, TextProps>(
  (
    { asChild, className = "", maxLines, style, ...props },
    ref,
  ): React.ReactElement => {
    const Comp: React.ElementType = asChild ? Slot : "p";

    return (
      <Comp
        ref={ref as React.LegacyRef<HTMLParagraphElement>}
        className={clsx(classes.root, className, {
          [classes.truncate as string]: maxLines,
        })}
        style={{ "--truncate": maxLines, ...style } as React.CSSProperties}
        {...props}
      />
    );
  },
);

Text.displayName = "Text";
